import { Link } from 'react-router-dom'
import { adminListApplications } from '../../api/auth'
import { ErrorBox } from '../ui/Card'
import { useFetch } from '../../hooks/useFetch'
import { DashboardWidgetCard } from './DashboardWidgetCard'

const ROLE_LABELS: Record<string, string> = {
  veterinarian: 'Veterinarian',
  vet_technician: 'Veterinary Technician',
  receptionist: 'Receptionist',
  non_clinical: 'Non-Clinical',
}

function formatDate(iso: string): string {
  return new Date(iso).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' })
}

export function PendingStaffApplicationsWidget() {
  const { data, loading, error } = useFetch(() => adminListApplications(), [])
  const pending = (data ?? [])
    .filter(a => a.status === 'pending_approval')
    .sort((a, b) => a.created_at.localeCompare(b.created_at))

  return (
    <DashboardWidgetCard title="Pending Staff Applications" viewAllHref="/admin/staff-applications">
      {loading ? (
        <div className="p-6 text-text-3 text-[0.875rem]">Loading…</div>
      ) : error ? (
        <div className="px-5 py-4"><ErrorBox className="mb-0">Could not load applications.</ErrorBox></div>
      ) : pending.length === 0 ? (
        <div className="px-5 py-6 text-text-3 text-[0.875rem]">No pending applications.</div>
      ) : (
        <div className="px-5 py-2">
          {pending.slice(0, 6).map(a => (
            <Link
              key={a.id}
              to="/admin/staff-applications"
              className="flex items-center justify-between gap-3 no-underline py-[0.6rem] border-b border-border last:border-b-0 hover:bg-surface-hover -mx-2 px-2 rounded transition-colors duration-150"
            >
              <div className="min-w-0">
                <div className="text-[0.875rem] font-medium text-text truncate">
                  {a.user_name ?? a.user_email}
                </div>
                <div className="text-[0.78rem] text-text-3 truncate">
                  {ROLE_LABELS[a.clinical_role] ?? a.clinical_role} — {a.practice_name}
                </div>
              </div>
              <div className="text-[0.78rem] text-text-3 whitespace-nowrap flex-shrink-0">
                {formatDate(a.created_at)}
              </div>
            </Link>
          ))}
        </div>
      )}
    </DashboardWidgetCard>
  )
}
